import update from 'immutability-helper'
import {
  BATCH_IMPORT_ACTIVE,
  BATCH_IMPORT_FAILED,
  BATCH_IMPORT_SUCCESS,
  CLEAR_PREVIOUS_IMPORT,
} from '../actions/action-types'

const initialState = {
  fileUploading: false,
  fileUpLoadComplete: false,
  fileUploadFailed: false,
  lastUpload: null,
  recordsRead: null,
  recordsImported: null,
}

// eslint-disable-next-line default-param-last
const batchImportUsers = (state = initialState, action) => {
  switch (action.type) {
    case BATCH_IMPORT_ACTIVE:
      return update(state, {
        fileUploading: { $set: true },
        fileUploadFailed: { $set: false },
      })
    case BATCH_IMPORT_FAILED:
      return update(state, {
        fileUploading: { $set: false },
        fileUploadFailed: { $set: true },
        recordsRead: { $set: action.recordsRead },
        recordsImported: { $set: action.recordsImported },
      })
    case BATCH_IMPORT_SUCCESS:
      return update(state, {
        fileUploading: { $set: false },
        fileUpLoadComplete: { $set: true },
        lastUpload: { $set: action.file.name },
      })
    case CLEAR_PREVIOUS_IMPORT:
      return initialState
    default:
      return state
  }
}

export default batchImportUsers
